import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import login from "../views/login.vue";
import home from "../views/home.vue";
// import business from "../views/business.vue";
const Settle = () =>
    import ("@/views/businessView/settle/Settle.vue");
// const regist = () =>
//     import ("@/views/businessView/settle/regist.vue");

const regist = () =>
    import ("@/views/businessView/register/Settle.vue");


const gologin = () =>
    import ("@/views/businessView/settle/gologin.vue");
import error404 from "../views/error/404.vue";
import error503 from "../views/error/503.vue";
import homeChildren from "./home/homeChildren";
import {
    Message
} from 'element-ui';

//解决路由重复点击报错
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};



const routes = [{
        path: "/",
        redirect: "/login",
    },
    {
        path: "/home",
        name: "home",
        redirect: "home/account",
        component: home,
        children: [...homeChildren],
    },
    {
        path: "/login",
        name: "login",
        component: login,
        meta: {
            isAuth: false,
        },
    },

    {
        path: "/home/settle",
        name: "settle",
        component: () =>
            import ("@/views/businessView/register/Settle.vue"),
        meta: {
            title: "商家入驻",
        },
    },
    // {
    //     path: "/Settle",
    //     name: "Settle",
    //     component: Settle,
    //     meta: {
    //         title: "商家入驻",
    //         isAuth: false,
    //     },
    // },
    {
        path: "/regist",
        name: "regist",
        component: regist,
        meta: {
            title: "商家入驻",
            isAuth: false,
        },
    },
    {
        path: "/gologin",
        name: "gologin",
        component: gologin,
        meta: {
            title: "商家入驻",
            isAuth: false,
        },
    },

    {
        path: "/404",
        name: "404",
        component: error404,
        meta: {
            isAuth: false,
        },
    },
    {
        path: "/503",
        name: "503",
        component: error503,
        meta: {
            isAuth: false,
        },
    },
    {
        path: "*",
        redirect: "/404",
    },
];

const router = new VueRouter({
    base: "/business/",
    mode: "history",
    scrollBehavior: () => ({
        x: 0,
        y: 0,
    }),
    routes,
});

// 路由守卫
router.beforeEach((to, form, next) => {
    if (to.fullPath == '/home/shopManage') {
      console.log(JSON.parse(localStorage.getItem('shop')).shop.length)
        if (JSON.parse(localStorage.getItem('shop')).shop.length > 0) {
            next({
                path: "/home/shopInfoManage"
            })
        }
    }
    if (to.meta && to.meta.title) {
        document.title = to.meta.title; //设置页面标题 不需要设置不同页面标题可删除
    } else {
        document.title = "商家后台管理系统";
    }
    if (to.meta && to.meta.isAuth === false) {
        // 判断该路由是否需要登录权限 false 为不需要登录
        next();
    } else {
        if (store.state.login) {
            next();
        } else {
            document.title = "商家后台管理系统";
            next({
                path: "/login",
            });
        }
    }
});

export default router;